<svg [attr.width]="svgWidth" [attr.height]="svgHeight" [attr.viewBox]="viewBox" [attr.aria-label]="ariaLabel()" role="img">
  @if (markerPath()) {
    @if (!isLineHidden()) {
      <line
        [attr.x1]="0"
        [attr.y1]="centerY"
        [attr.x2]="leftSegmentEnd"
        [attr.y2]="centerY"
        [attr.stroke]="lineColor()"
        [attr.stroke-width]="strokeWidth()"
        [attr.stroke-dasharray]="dashArray()"
        stroke-linecap="round" />
      @if (hasDash()) {
        <line
          [attr.x1]="markerX - centerDashHalf"
          [attr.y1]="centerY"
          [attr.x2]="markerX + centerDashHalf"
          [attr.y2]="centerY"
          [attr.stroke]="lineColor()"
          [attr.stroke-width]="strokeWidth()"
          stroke-linecap="round" />
      }
      <line
        [attr.x1]="rightSegmentStart"
        [attr.y1]="centerY"
        [attr.x2]="svgWidth"
        [attr.y2]="centerY"
        [attr.stroke]="lineColor()"
        [attr.stroke-width]="strokeWidth()"
        [attr.stroke-dasharray]="dashArray()"
        stroke-linecap="round" />
    }
    <g [attr.transform]="markerTransform">
      @if (isStrokeOnlyMarker()) {
        <path
          [attr.d]="markerPath()"
          fill="none"
          [attr.stroke]="markerColor()"
          [attr.stroke-width]="crossStrokeWidth"
          stroke-linecap="round" />
      } @else {
        <path
          [attr.d]="markerPath()"
          [attr.fill]="markerColor()"
          [attr.stroke]="markerColor()"
          [attr.stroke-width]="markerStrokeWidth" />
      }
    </g>
  } @else if (!isLineHidden()) {
    <line
      [attr.x1]="0"
      [attr.y1]="centerY"
      [attr.x2]="svgWidth"
      [attr.y2]="centerY"
      [attr.stroke]="lineColor()"
      [attr.stroke-width]="strokeWidth()"
      [attr.stroke-dasharray]="dashArray()"
      stroke-linecap="round" />
  }
</svg>
